import type {
  CustomAssetViewVisitedEntry,
  DefaultAssetViewVisitedEntry,
  SnoPatternMatchVisitedEntry,
} from '@/custolink-views/asset_frontend/visited_assets'
import type { VisitedEntry } from './useHomeModel'

export type VisitedLink = {
  to: string
  primary: string
  secondary: string
}

/**
 * Turns a stored "recently visited" entry into a link and two labels. The three
 * entry shapes are the ones `visitAsset` writes; the mapping matches the
 * existing recent table exactly, including the URL encoding.
 */
export function visitedLink(entry: VisitedEntry): VisitedLink | null {
  const custom = entry as CustomAssetViewVisitedEntry
  if (custom.slug != null && custom.value != null) {
    return {
      to: '/view/' + custom.slug + '/' + encodeURIComponent(custom.value),
      primary: custom.title,
      secondary: custom.value,
    }
  }

  const sno = entry as SnoPatternMatchVisitedEntry
  if (sno.snoSerialName != null) {
    return {
      to: '/asset/' + encodeURIComponent(sno.snoSerialName),
      primary: sno.productName,
      secondary: sno.snoSerialName,
    }
  }

  const def = entry as DefaultAssetViewVisitedEntry
  if (def.serialName != null) {
    return {
      to: '/asset/' + encodeURIComponent(def.serialName),
      primary: def.productName,
      secondary: def.serialName,
    }
  }

  return null
}
